import {ServerModalV3} from "./ServerModalV3";
import {getSingleInputByNameV3} from "../../forms/formInputsHelpers";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts file
/**
 * Handles grid modals pulled from the server
 */
class ServerGridModalV3 extends ServerModalV3 {
	/** @var {ServerGridModalV3Defs.Config} */
	config;
	/** @var {import('../../grids/grids').GridInstance} */
	gridInstance;

	init() {
		// Run any initialization before grid starts
		this.initBeforeGridStart();

		// This should take care of populating this.gridInstance
		this.initGridView();

		// By default call init function from config if set
		if (this.config.init) {
			this.config.init(this);
		}
	}

	initBeforeGridStart() {

	}

	initGridView() {
		// Let each child modal handle creating the grid
	}

	getGridContainer() {
		return this.modalContainer.querySelector('.grid');
	}

	getGridRoute() {
		return getSingleInputByNameV3(this.modalContainer, 'grid_route');
	}

	display(firstTime) {
		super.display(firstTime);

		// Focus search input after modal is displayed
		setTimeout(() => {
			this.focusSearchInput();
		}, 512)
	}

	getSearchInput() {
		return this.modalContainer.querySelector(
			'input[name="search"]'
		);
	}

	focusSearchInput() {
		const searchInputElement = this.getSearchInput();

		if (searchInputElement) {
			searchInputElement.focus()
		}
	}
}

export {ServerGridModalV3}
